import React from 'react';
import Grid from '@material-ui/core/Grid';
import { MenuDish } from '../constants/type.constant';
import _ from 'lodash';
import { StateManager } from '../redux/stateManager';
import NormalDish from './normal-dish.component';

// 加入或移出购物车
enum UPGRADE {
    REMOVE_DISH = -1,
    ADD_DISH = 1,
}

// 菜品轮播图模式组件(列表模式)
export default class FoodNormal extends React.Component<Props, State>{

    public state: State = {
        menuDish: []
    };
    // *********************
    // 生命周期
    // *********************

    // shouldComponentUpdate(nextProp: any, nextState: State) {
    //     // 判断前后点击是否一致，避免重复渲染
    //     if (_.isEqual(this.props.menuDisplayMode, nextProp.menuDisplayMode)) {
    //         return false;
    //     }
    // }

    //     return true;
    public UNSAFE_componentWillMount() {
        const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2');
        if (findRes) this.isShowName1 = findRes.value.showItemName1
    }

    // *********************
    // 方法区
    // *********************
    public isShowName1 = true;
    public getSettingInfoValue(str: string) {
        const SETTING = StateManager.getFromCache('settingInfo');
        return _.find(SETTING, ['name', str]);
    }


    // *********************
    // 视图区
    // *********************
    public render() {
        const { menuDish, changeMenuQuantity, openMenuDetail, customer, showTip, cacheGuidePageHideCard, openSetDishDetail, currency_name } = this.props;
        return (
            <div className={'food smallFood'} style={{ padding: '0 5px' }}>
                <Grid container spacing={1} className="boxContainer">
                    {menuDish.map(((item, index) => {
                        return (
                            <NormalDish
                                liteMode={this.props.liteMode}
                                key={`${index}${item.item_id}`}
                                eIndex={index}
                                item={item}
                                changeMenuQuantity={changeMenuQuantity}
                                openMenuDetail={openMenuDetail}
                                customer={customer}
                                showTip={showTip}
                                cacheGuidePageHideCard={cacheGuidePageHideCard}
                                openSetDishDetail={openSetDishDetail}
                                currency_name={currency_name}
                            />
                        )
                    }))}
                </Grid>
            </div>

        )
    }
}

type Props = {
    // 选中的二级菜单的菜品
    menuDish: Array<MenuDish & { history_num?: number }>
    /**
     * 更新购物车
     * @param dish 菜品数据`Dish`
     * @param type 操作类型` UPGRADE_OPERATES`
     */
    changeMenuQuantity(dish: MenuDish, type: UPGRADE, expandDish?: MenuDish): void
    /**
     * 打开菜品大图
     * @param initialSlide 初始化时slide的索引
     */
    openMenuDetail(initialSlide: number): void
    customer: string
    // 精简版模式
    liteMode?: boolean;
    // 显示引导层
    showTip?: boolean;
    // 引导层
    cacheGuidePageHideCard: boolean;
    // 打开套餐详情弹窗
    openSetDishDetail?(initialSlide: number): void;
    // 货币文本
    currency_name: string;
}

type State = {
    menuDish: Array<MenuDish & { history_num?: number }>
}
